export function countersAnimation() {
    $("[data-digits-counter]").each(function () {
        let $this = $(this);
        let countValue = $this.text();
        $this.attr("data-count-text", countValue);
        if (countValue.includes(',')) {
            let beforeComa = countValue.toString().split(',')[0];
            let afterComa = countValue.toString().split(',')[1];
            // $this.text(beforeComa);
            $this.attr("data-count-text", beforeComa);
            if (afterComa >= 1) {
                $this.after("<span>,</span><span data-digits-counter data-count-text='" + afterComa + "'>" + afterComa + "<span>");
            } else {
                $this.after("<span>,</span><span>" + afterComa + "<span>");
            }
        }
        if (countValue.includes('.')) {
            let beforeComa = countValue.toString().split('.')[0];
            let afterComa = countValue.toString().split('.')[1];
            // $this.text(beforeComa);
            $this.attr("data-count-text", beforeComa);
            if (afterComa >= 1) {
                $this.after("<span>.</span><span data-digits-counter data-count-text='" + afterComa + "'>" + afterComa + "<span>");
            } else {
                $this.after("<span>.</span><span>" + afterComa + "<span>");
            }
        }

    });
    window.addEventListener('load', runCountersAnimation);

    function runCountersAnimation() {
        function digitsCountersInit(digitsCountersItems) {
            const digitsCounters = digitsCountersItems ? digitsCountersItems : document.querySelectorAll("[data-digits-counter]");

            if (digitsCounters.length) {
                digitsCounters.forEach(digitsCounter => {
                    digitsCountersAnimate(digitsCounter);
                })
            }
        }

        function digitsCountersAnimate(digitsCounter) {
            let startTimestamp = null;
            const duration = parseInt(digitsCounter.dataset.digitsCounter) ? parseInt(digitsCounter.dataset.digitsCounter) : 2000;
            // const startValue = digitsCounter.innerText;
            const startValue = digitsCounter.dataset.countText;
            const startValueParsed = parseInt(startValue.replace(/,/g, ''));
            const startPosition = 0;
            const step = (timestamp) => {
                if (!startTimestamp) startTimestamp = timestamp;
                const progress = Math.min((timestamp - startTimestamp) / duration, 1);
                let currentCount = Math.floor(progress * (startPosition + startValueParsed));

                // if (startValue.includes(',')) {
                //     currentCount = currentCount.toString().replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,")
                // }

                digitsCounter.innerHTML = currentCount;

                if (progress < 1) {
                    window.requestAnimationFrame(step);
                }
            };
            window.requestAnimationFrame(step);
        }

        // run on scroll
        const options = {threshold: 0.3};
        const observer = new IntersectionObserver((entries, observer) => {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const targetElement = entry.target;
                    const digitsCountersItems = targetElement.querySelectorAll("[data-digits-counter]");
                    if (digitsCountersItems.length) {
                        digitsCountersInit(digitsCountersItems);
                    }
                    observer.unobserve(targetElement);
                }
            });
        }, options);
        const countersSections = document.querySelectorAll(".has-counters-animation");

        if (countersSections.length) {
            countersSections.forEach(section => {
                observer.observe(section);
            });
        }
    }
}


// WEBPACK FOOTER //
// ./assets/js/modules/countersAnimation.js